const ASIDE_STYLE = {
  mb: 'var(--aside-mb)'
}

export default ASIDE_STYLE
